import { MessageCircle, Phone } from "lucide-react";
import { COMPANY } from "@/lib/data";

export default function FloatingActions() {
  const waUrl = `https://wa.me/${COMPANY.phoneRaw.replace("+", "")}?text=${encodeURIComponent(COMPANY.whatsappMsg)}`;

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3">
      <a
        data-testid="floating-call-btn"
        href={`tel:${COMPANY.phoneRaw}`}
        className="w-14 h-14 rounded-full bg-[#0F3D8C] dark:bg-[#2563EB] text-white flex items-center justify-center shadow-2xl hover:scale-110 transition-transform"
        aria-label="Call us"
      >
        <Phone className="w-6 h-6" />
      </a>
      <a
        data-testid="floating-whatsapp-btn"
        href={waUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-2xl pulse-ring hover:scale-110 transition-transform"
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle className="w-6 h-6 fill-white" />
      </a>
    </div>
  );
}
